import React, { useRef } from 'react';
import toast from 'react-hot-toast';

import DocumentUploadItem from './DocumentUploadItem';
import { useFinancialVerification } from './FinancialVerificationContext';

const MAX_FILE_SIZE = 10 * 1024 * 1024;
const MAX_FILE_SIZE_MB = MAX_FILE_SIZE / (1024 * 1024);

export default function OtherFinancialDocuments() {
  const {
    uploadedDocuments,
    uploadDocument,
    removeDocument,
    financialDocuments,
  } = useFinancialVerification();
  const fileInputRefs = useRef({});

  const handleUpload = (documentId) => {
    const fileInput = fileInputRefs.current[documentId];
    if (fileInput) {
      fileInput.click();
    }
  };

  const handleFileSelect = (documentId, event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        toast.error(
          `File is too large. Please upload a file smaller than ${MAX_FILE_SIZE_MB}MB.`
        );
        event.target.value = '';
        return;
      }
      uploadDocument(documentId, file);
    }
  };

  const handleRemove = (documentId) => {
    removeDocument(documentId);
    if (fileInputRefs.current[documentId]) {
      fileInputRefs.current[documentId].value = '';
    }
  };

  if (!financialDocuments || financialDocuments.length === 0) {
    return null;
  }

  return (
    <div className="bg-white border border-primary-border-gray rounded-lg p-4 mb-6">
      <h3 className="text-base font-medium">Other Financial Documents</h3>
      <div className="flex flex-col gap-4 py-6">
        <div className="flex flex-col gap-4">
          {financialDocuments.map((doc) => (
            <div key={doc.id}>
              <DocumentUploadItem
                title={doc.title}
                description={doc.description}
                isRequired={doc.isRequired}
                onUpload={() => handleUpload(doc.id)}
                onRemove={() => handleRemove(doc.id)}
                uploadedFile={uploadedDocuments[doc.id]}
              />
              <input
                ref={(el) => (fileInputRefs.current[doc.id] = el)}
                type="file"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                onChange={(e) => handleFileSelect(doc.id, e)}
                style={{ display: 'none' }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
